// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"d4d11c59","171":"8f1eb8ee","488":"46e93d17","994":"09387978"}[chunkId] + ".chunk.js";
};